import React, { Component } from "react";

import "../../styles/components/Dynamic/DynamicDeputet.css";

import { Row, Col } from "reactstrap";
import Deputet from "../Deputet";

class DynamicDeputet extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    console.warn(this.props);
  }

  dataToDeputet = () => {
    return this.props.data.map(el => {
      return (
        <Col xs="6" sm="3" md="3" lg="2">
          <Deputet
            emri={el.emri}
            mbiemri={el.mbiemri}
            foto={
              "https://www.parlament.al/Files/AnetareFoto/" +
              el.emer
                .toLowerCase()
                .replace("ç", "c")
                .replace("ë", "e") +
              el.mbiemer
                .toLowerCase()
                .replace("ç", "c")
                .replace("ë", "e") +
              "_foto.jpg"
            }
            email={el.email}
            atesia={el.atesia}
            datelindja={el.datelindja || "1969-10-3"}
            vendlindja={el.qarku}
            cv={el.cvPath}
          />
        </Col>
      );
    });
  };

  render() {
    return (
      <div>
        <div className="dynamicDeputetBody">
          <Row>{this.dataToDeputet()}</Row>
        </div>
      </div>
    );
  }
}
export default DynamicDeputet;
